var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9997 0.332031C18.958 0.332031 0.333008 18.957 0.333008 41.9987C0.333008 65.0404 18.958 83.6654 41.9997 83.6654C65.0413 83.6654 83.6664 65.0404 83.6664 41.9987C83.6664 18.957 65.0413 0.332031 41.9997 0.332031ZM62.833 56.957L56.958 62.832L41.9997 47.8737L27.0413 62.832L21.1663 56.957L36.1247 41.9987L21.1663 27.0404L27.0413 21.1654L41.9997 36.1237L56.958 21.1654L62.833 27.0404L47.8747 41.9987L62.833 56.957Z",
    fill: "#B50E37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/IconError.9bc1131748844e968b759c884ebb8601.svg";
export { ForwardRef as ReactComponent };